/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import endpointConfig from "../config/endpoints.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { IMPORT_LOCAL_ASSETS } from "../graphql";
import { VApplication } from "../../../application";
import { pretty } from "@vlinder-web/utils-react";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGroupServiceMethods extends IPluginMethodMap {
  createGroup(args: any): any;
}

export class GroupService implements IAgentPlugin {
  readonly methods: IGroupServiceMethods;

  constructor() {
    this.methods = {
      createGroup: this.createGroup.bind(this),
    };
  }

  async createGroup(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const res = await client.mutate({
          mutation: IMPORT_LOCAL_ASSETS,
          variables: {
            presentationId: args?.presentationId,
            sectionId: args?.sectionId,
            costumeTypeId: args?.costumeTypeId,
            data: args?.validData || [],
          },
          fetchPolicy: "no-cache",
        });

        return res?.data?.importLocalAssetFeatureFromCsv;
      }
    } catch (err: any) {
      const _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);

      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message.extensions.display_message);
      }

      throw err;
    }
  }
}
